import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import CONFIG from 'src/app/app.config';
import { FirebaseService } from 'src/app/d3/services/firebase.service';
import { AnalyticsService } from 'src/app/services/tracking/analytics.service';
import { UserdataService } from 'src/app/services/user/userdata.service';
import { environment } from 'src/environments/environment';

// Make request to payment endpoint, which should return a link, which is then used to redirect use
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
    host: {
    'class':  'container cc-component-container cc-wrapper-container pt-5 pt-sm-3', 
  }
})
export class PaymentComponent implements OnInit, OnDestroy, AfterViewInit {
  title: string = '';

  private pLinkUrl = `${environment.fbServer.basePath}${environment.fbServer.plink}`;
  loadError$ = new BehaviorSubject<boolean>(false);
  paymentSuccessful = false;
  disableSubmit = false;
  isLoading= true;
  statusMessage$ = new BehaviorSubject<string>('Redirecting...');
  pricingPath = CONFIG.APPLICATION.PATHS.PRICING;
  packages = CONFIG.APPLICATION.PACKAGES;
  items = CONFIG.APPLICATION.FEATURES;
  selectPackage = {};

  constructor(
    private httpClient: HttpClient,
    private firebaseService: FirebaseService,
    private userDataService: UserdataService,
    private route: ActivatedRoute,
    private router: Router,
    private cd: ChangeDetectorRef,
    private analytics: AnalyticsService) { 
      this.route.queryParams.subscribe((param: any) => {
        this.title = param.p;
      });
  }

  async ngAfterViewInit() {
    this.analytics.setCurrentScreen(CONFIG.APPLICATION.ANALYTICS.SCREENS.PAYMENT_START);
    this.initPlink();
  }

  ngOnDestroy(): void {}

  async ngOnInit() {}

  async initPlink() {
    this.userDataService.userDetails$.subscribe((user) => {
      if(!user) return;
      const payload = {
        plan: this.title
      };
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${user.accessToken}`,
        'Content-Type': 'application/json', 
      });
      this.statusMessage$.next('Generating payment link...');
      this.httpClient.post(this.pLinkUrl, payload, { headers })
        .subscribe(({ data }: any) => {
          if(data.success) {
            this.loadError$.next(false);
            this.statusMessage$.next('Redirecting to payment service...');
            window.location.href = data.paymentUrl;
          }
        },
        (err) => {
          this.paymentSuccessful = false;
          this.loadError$.next(true);
          this.statusMessage$.next('Opps.. something happend');
          this.analytics.logEvent(this.analytics.PAGE_VIEW, "Fail to process event: " + err);
          console.error('Failed to create payment link');
        })
      });
  }

  async refresh() {
    console.log('Refreshing...');
    this.statusMessage$.next('Retrying the request...');
    //  Submit a refresh token
    this.initPlink();
  }

  cancel() {
    this.router.navigate([ this.pricingPath ]);
  }
}
